import {AnimationBaseController, IAnimationControllerConfiguration, Inject} from "@denishussar/html5-game-engine";
import {PrintCardModel} from "../Models/PrintCardModel";
import {GameLogic as PrintCardLogic} from "../Logic/PrintCardLogic";
import {GameLogic} from "../../../../../Logic/GameLogic";
import {MiniGameTypeEnum} from "../../../../../Models/Game/MiniGameModel";

export class LeverController extends AnimationBaseController {
    $model: PrintCardModel;
    private _answerCounter: number = 0;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic,
        @Inject private _logic: PrintCardLogic
    ) {
        super("LeverController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            modelWatch: {
                lever: (lever) => {
                    lever === "lever_down"
                        ? this._changeLever()
                        : this.$queue.get("leverUp").addToQueue(2);
                },
            },
            queue: {
                leverUp: {
                    condition: (time) => time > 0.3,
                    action: () => {
                        this._changeLever()
                    },
                },
                win: {
                    condition: (time) => time > 0.5,
                    action: () => {
                        if (this._answerCounter > 0) {
                            this._gameLogic.onMiniGameFail(MiniGameTypeEnum.print_card);
                        }
                        this._gameLogic.onMiniGameComplete(MiniGameTypeEnum.print_card);
                    },
                },
            },
            onPointerDown: (e) => {
                if (this._logic.changeLever()) {
                    this.$queue.get("win").addToQueue(3);
                } else {
                    this._answerCounter++
                }
            },
            onPointerOver: () => {
            },
        };
    }

    private _changeLever() {
        this.gotoAndStop(this.$model.lever)
    }

    protected onInitialize(): void {
        this._changeLever()
    }

    protected onAnimationEvent(name: string, ...args): void {
    }
}
